
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4340"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4340"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $1Knfl = parcelRequire("1Knfl");

var $kB2C5 = parcelRequire("kB2C5");

var $29Z9A = parcelRequire("29Z9A");

var $aqOVV = parcelRequire("aqOVV");
var $kMjUy = parcelRequire("kMjUy");
var $cobnL = parcelRequire("cobnL");
var $cNXNW = parcelRequire("cNXNW");
var $lHFYh = parcelRequire("lHFYh");

var $3bzuQ = parcelRequire("3bzuQ");

var $1WwBr = parcelRequire("1WwBr");

var $1qliK = parcelRequire("1qliK");
//
const $87c22c47a9940fdc$var$ALGOLIA_APP_ID = "XS4X4GJGA8";
const $87c22c47a9940fdc$var$ALGOLIA_API_KEY = "1b6bee0488dc899e58e57f748383e757";
const $87c22c47a9940fdc$var$ALGOLIA_INDEX_NAME = "api_data_idx";
// setup the search client.
const $87c22c47a9940fdc$var$searchClient = (0, $1Knfl.liteClient)($87c22c47a9940fdc$var$ALGOLIA_APP_ID, $87c22c47a9940fdc$var$ALGOLIA_API_KEY);
const $87c22c47a9940fdc$var$search = (0, $kB2C5.default)({
    searchClient: $87c22c47a9940fdc$var$searchClient,
    appId: $87c22c47a9940fdc$var$ALGOLIA_APP_ID,
    indexName: $87c22c47a9940fdc$var$ALGOLIA_INDEX_NAME,
    apiKey: $87c22c47a9940fdc$var$ALGOLIA_API_KEY,
    insights: false
});
// *
// * Define the search widgets
// *   See: https://www.algolia.com/doc/api-reference/widgets/js/
// *
const $87c22c47a9940fdc$var$widgets = [
    // setup base configuration
    (0, $kMjUy.default)({
        hitsPerPage: 51,
        distinct: true
    }),
    //
    // Create the "Destination" select box
    (0, $cobnL.default)({
        container: "#refinement-destination",
        attribute: "geoAreas",
        sortBy: [
            "count:desc"
        ],
        limit: 500,
        // showMore: true,
        templates: {
            defaultOption (data, { html: html }) {
                return html`<span>Anywhere</span>`;
            }
        },
        cssClasses: {
            select: "bg-gray-100 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        }
    }),
    //
    // Create the "Yacht Type" select box
    (0, $cobnL.default)({
        container: "#refinement-yachtType",
        attribute: "yachtType",
        sortBy: [
            "name:asc"
        ],
        limit: 99,
        templates: {
            defaultOption (data, { html: html }) {
                return html`<span>Any</span>`;
            }
        },
        cssClasses: {
            select: "bg-gray-100 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        }
    }),
    //
    // Create the "Yacht Length" select box
    (0, $29Z9A.default)((0, $1WwBr.selectMinMax))({
        el: "#refinement-length",
        attribute: "length_m"
    }),
    //
    // Create the "Number of Guests" select box
    //  Note: * for "TERM" charters, this is the "sleeps" field.
    //        * for "DAY" charters, this is the "cruisingCapacity" field.
    //        * these fields are ~mutually exclusive (that is, they will
    //        * only be set in the index if that charter type is available)
    (0, $29Z9A.default)((0, $1WwBr.selectMinMax))({
        el: "#refinement-sleeps",
        attribute: "sleeps"
    }),
    //
    // refinements - dates
    (0, $29Z9A.default)((0, $3bzuQ.textDateAfter))({
        el: "#refinement-embarkation",
        attribute: "effectiveDateFrom"
    }),
    (0, $29Z9A.default)((0, $3bzuQ.textDateBefore))({
        el: "#refinement-disembarkation",
        attribute: "effectiveDateTo"
    }),
    //
    // create stats area
    (0, $lHFYh.default)({
        container: "#stats"
    }),
    //
    // allow refinements to be cleared
    (0, $aqOVV.default)({
        container: "#clear-refinements",
        templates: {
            resetLabel ({ hasRefinements: hasRefinements }, { html: html }) {
                return html`<span>${hasRefinements ? "[ Reset ]" : ""}</span>`;
            }
        }
    }),
    //
    // the hits!
    //  https://www.algolia.com/doc/api-reference/widgets/hits/js/
    (0, $1qliK.customHits)({
        container: document.querySelector("#hits")
    }),
    //
    // this example will use pagination.
    (0, $cNXNW.default)({
        container: "#pagination",
        cssClasses: {
            root: "w-full",
            list: "flex justify-center",
            item: "mx-2 px-2",
            selectedItem: "bg-gray-200 underline",
            link: "text-blue-800"
        }
    })
];
$87c22c47a9940fdc$var$search.addWidgets($87c22c47a9940fdc$var$widgets);
$87c22c47a9940fdc$var$search.start();


//# sourceMappingURL=search-facets.8e65b9e6.js.map
